// polyfill features in the older browsers -----------------------------------
import "core-js/stable";
import "regenerator-runtime/runtime";
import "stylesheets/application";
import ReactDOM from "react-dom";

require("@rails/ujs").start();
